<template>
    <div class="dashboard-edit">
        <div class="dashboard_contents">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <tabs class="pets-component">
                            <tab name="Свои животные" :selected="true">
                                <div class="tabs__body">
                                    <pets-myself :user="user" @pagination="getPetsMyself" @archive-refresh="getPetsArchive(1)"
                                                 :pets="petsMyself" tab-type="PET_TYPE_MYSELF"/>
                                </div>
                            </tab>
                            <tab name="Архив животных" v-if="petsArchive.list.length">
                                <div class="tabs__body">
                                    <pets-archive :user="user" @pagination="getPetsArchive" :pets="petsArchive"/>
                                </div>
                            </tab>
                            <tab name="Передержка" v-if="userFacilities && (+userFacilities.homestay > 0)">
                                <div class="tabs__body">
                                    <tab-homestays />
                                </div>
                            </tab>
                            <tab name="Обьявления" v-if="userFacilities && (+userFacilities.facilities > 0)">
                                <div class="tabs__body">
                                    <tab-facilities :selectCategory="selectPhotoHelp"/>
                                </div>
                            </tab>
                        </tabs>

                    </div>
                </div>

            </div>
            <!-- end /.container -->
        </div>
    </div>
</template>

<script>

import Tabs from '../tabs/Tabs'
import Tab from '../tabs/Tab'
import PetsMyself from './UserClassifiedsPetsMyself'
import PetsArchive from './UserClassifiedsPetsArchive'
import TabHomestays from "../tabs/TabPet/TabHomestays";
import TabFacilities from "../tabs/TabPet/TabFacilities";

export default {
    name: "UserClassifieds",
    props: ['user'],
    components: {Tabs, Tab, PetsMyself, PetsArchive, TabHomestays, TabFacilities},
    data(){
        return{
            petsMyself: {
                list: [],
                pageCount: 1,
            },
            petsArchive: {
                list: [],
                pageCount: 1,
            },
            selectPhotoHelp:{
                placeholder: 'Тип услуги',
                list: [
                    {
                        id: 'photo_help',
                        name: 'Фотопомощь',
                    },
                    {
                        id: 'pr_help',
                        name: 'PR',
                    },
                    {
                        id: 'auto_help',
                        name: 'Автопомощь',
                    },
                    {
                        id: 'giveaway',
                        name: 'Отдам даром',
                    },

                ]
            },
        }
    },

    mounted(){
        this.getPetsMyself()
        this.getPetsArchive()
    },

    computed: {

        userFacilities(){
            let stateFacilities = this.$store.getters.getFacilities;


            return {
                homestay: stateFacilities.homestay || 0,
                facilities: (+stateFacilities.auto_help || 0) + (+stateFacilities.giveaway || 0) + (+stateFacilities.photo_help || 0) + (+stateFacilities.pr_help || 0)
            };
        }

    },


    methods:{
        getPetsMyself(page = 1) {
            let url = `/user/${this.user.id}/pets`,
                params = {
                    type: 'PET_TYPE_MYSELF',
                    status: 1,
                    page: page,
                    is_moderated: 'any',
                };

            axios.get(url, {params: params})
                .then(response => {
                    response = response.data;
                    if (response.success) {
                        this.petsMyself.list = response.data;
                        this.petsMyself.pageCount = response.meta.last_page;
                    }
                })
                .catch(error => {
                    error = error.response.data

                    if(!error.success) console.log(error)

                });
        },

        getPetsArchive(page = 1) {
            let url = `/user/${this.user.id}/pets`,
                params = {
                    status: 0,
                    page: page,
                    is_moderated: 'any',
                };


            axios.get(url, {params: params})
                .then(response => {
                    response = response.data;
                    if (response.success) {
                        this.petsArchive.list = response.data;
                        this.petsArchive.pageCount = response.meta.last_page;
                    }
                })
                .catch(error => {
                    error = error.response.data

                    if(!error.success) console.log(error)

                });
        },

    }

}
</script>

<style scoped>

</style>
